import { render, staticRenderFns } from "./SupplierManageMaterial.vue?vue&type=template&id=326eabbc&scoped=true&"
import script from "./SupplierManageMaterial.vue?vue&type=script&lang=js&"
export * from "./SupplierManageMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326eabbc",
  null
  
)

export default component.exports